import * as yup from "yup";

const FIELD_LETTERS_ONLY = "Este campo solo acepta letras";
const FIELD_REQUIRED = "Este campo es obligatorio";
const FIELD_EMAIL_INVALID = "Ingresa un correo válido";
const FIELD_PHONE_NUMBER_INVALID = "Ingresa un número de celular válido";

export const schema = yup.object({
  firstName: yup
    .string()
    .required(FIELD_REQUIRED)
    .matches(/^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$/, FIELD_LETTERS_ONLY),
  lastName: yup
    .string()
    .required(FIELD_REQUIRED)
    .matches(/^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$/, FIELD_LETTERS_ONLY),
  email: yup
    .string()
    .required(FIELD_REQUIRED)
    .matches(
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      FIELD_EMAIL_INVALID
    ),
  emailStudent: yup
    .string()
    .required(FIELD_REQUIRED)
    .matches(
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      FIELD_EMAIL_INVALID
    ),
  phoneNumberNational: yup
    .string()
    .min(6, FIELD_PHONE_NUMBER_INVALID)
    .max(14, FIELD_PHONE_NUMBER_INVALID)
    .required(FIELD_REQUIRED),
  countryItem: yup
    .object({
      code: yup.string().required(FIELD_REQUIRED),
      label: yup.string().required(FIELD_REQUIRED),
    })
    .typeError(FIELD_REQUIRED)
    .required(FIELD_REQUIRED),
});
